<!-- 充值对话框 -->
<template>
<el-dialog
    title="提示"
    class="gold-recharge"
    :visible.sync="status"
   
    :before-close="handleClose">
    
    <div class="cont-row recharge-title" slot="title">
        <div class="main">快速充值</div>
        <div class="subf">1加币=100金币</div>
    </div>
    <ul class="recharge-list" v-if="!payStatus">
        <li :class="{active:amount == 5}" @click="amount = 5"><div class="box"><span class="count">5</span><span class="unit">加币</span></div></li>
        <li :class="{active:amount == 10}" @click="amount = 10"><div class="box"><span class="count">10</span><span class="unit">加币</span></div></li>
        <li :class="{active:amount == 20}" @click="amount = 20"><div class="box"><span class="count">20</span><span class="unit">加币</span></div></li>
        <li :class="{active:amount == 50}" @click="amount = 50"><div class="box"><span class="count">50</span><span class="unit">加币</span></div></li>
        <li :class="{active:amount == 100}" @click="amount = 100"><div class="box"><span class="count">100</span><span class="unit">加币</span></div></li>
        <li class="other-amount"><div class="box"><el-input v-model.trim="otherAmount" placeholder="其他金额" @focus="amount = null"></el-input></div></li>
    </ul>
    <div class="result cont-row flex-center mrg-btm30" v-if="!payStatus">
        <div class="flex-cont"></div>
        <div class="cont charge-gold" v-if="rechareResult">共计{{rechareResult}}金币</div>
        <div class="cont now-recharge"  @click="nowRecharge">立即充值</div>
    </div>
    <div id="paypal-button-container" ref="paypal"></div>
    <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="ensure">确 定</el-button>
    </span> -->
</el-dialog>
</template>
<script>
export default {
    name:'GoldRecharge',
    props:['status'],
    computed:{
        rechareResult(){
            if(this.amount != null ){
                return this.amount*100;
            }else if( this.otherAmount.length > 0 ){
                return parseInt(this.otherAmount)*100
            }else{
                return 0;
            }
        }
    },
    data(){
        return {
            amount:null,
            otherAmount:'',
            payStatus:false,
        }
    },
    methods:{
        handleClose(){
            this.$emit('update:status',false)
            this.$refs.paypal.innerHTML = '';
            this.payStatus = false; 
        },
        ensure(){},
        nowRecharge(){
            let moneyValue = 0;
            if( this.amount == null ){
                if( this.otherAmount.length == 0){
                    this.$warning('请填写金额');
                    return false
                }
                if( /^\d+$/.test(this.otherAmount) == false ){
                    this.$warning('金额请填写数字');
                    return false;
                }
                moneyValue = parseInt(this.otherAmount)
            }else{
                moneyValue = this.amount;
            }
            if( moneyValue == 0 ){
                this.$warning('充值金额不能为0');
                return false;
            }
            this.payStatus = true;
            window.paypal.Buttons({
            // Order is created on the server and the order id is returned
                createOrder: (data, actions) => {
                    return this.$axios.post('/worldcup2022/paypal/create/order',{
                        "amount": moneyValue*100
                    }).then((res)=>res.orderId)
                    /* return fetch("/api/orders", {
                        method: "post",
                        // use the "body" param to optionally pass additional order information
                        // like product ids or amount
                    })
                    .then((response) => response.json())
                    .then((order) => order.id); */
                },
                // Finalize the transaction on the server after payer approval
                onApprove: (data, actions) => {
                    return this.$axios.post('/worldcup2022/paypal/capture/order',{
                        'orderId':data.orderID
                    }).then((orderData) => {
                        if( orderData.code == 0 ){
                            if( orderData.order.status == 'COMPLETED'){
                                this.$success('充值成功!');
                                this.handleClose()
                                this.$emit('success')
                            }else{
                                this.$warning('充值失败');
                            }
                            
                        }else{
                            this.$warning(orderData.msg)
                        }
                        // Successful capture! For dev/demo purposes:
                        //console.log('Capture result', orderData, JSON.stringify(orderData, null, 2));
                        //const transaction = orderData.purchase_units[0].payments.captures[0];
                        //alert(`Transaction ${transaction.status}: ${transaction.id}\n\nSee console for all available details`);
                        // When ready to go live, remove the alert and show a success message within this page. For example:
                        // const element = document.getElementById('paypal-button-container');
                        // element.innerHTML = '<h3>Thank you for your payment!</h3>';
                        // Or go to another URL:  actions.redirect('thank_you.html');
                    });
                    /* return fetch(`/api/orders/${data.orderID}/capture`, {
                        method: "post",
                    })
                    .then((response) => response.json())
                    .then((orderData) => {
                        // Successful capture! For dev/demo purposes:
                        console.log('Capture result', orderData, JSON.stringify(orderData, null, 2));
                        const transaction = orderData.purchase_units[0].payments.captures[0];
                        alert(`Transaction ${transaction.status}: ${transaction.id}\n\nSee console for all available details`);
                        // When ready to go live, remove the alert and show a success message within this page. For example:
                        // const element = document.getElementById('paypal-button-container');
                        // element.innerHTML = '<h3>Thank you for your payment!</h3>';
                        // Or go to another URL:  actions.redirect('thank_you.html');
                    }); */
                }
            }).render('#paypal-button-container');
        }
    },
    created(){
        if(!document.querySelector('#topic-pay')){
                let script = document.createElement('script');
                script.src ='https://www.paypal.com/sdk/js?client-id=AUR0wFSB0qo5zhPxC7KiaQa-4pz2Q57PaFqIVvbkJ4HixXEipaJkgJbljZPuMlqzYejDEo-EKpRvUNjQ&currency=CAD';
                script.id = 'topic-pay';
                document.head.appendChild(script)
        }
    },
    mounted(){
        console.log(document.querySelector('#topic-pay'))
        
        
    }

}
</script>
<style lang="less" scoped>
.gold-recharge{
    /deep/.el-dialog{
        width: 500px;
    }
}
@media screen and (max-width:768px){
    .gold-recharge{
        /deep/.el-dialog{
            width: 90%;
        }
    }
}
.recharge-title{
    .main{font-size: 18px; line-height: 30px; font-weight: bold; color: #000;}
    .subf{font-size: 18px; line-height: 30px; color: #999; margin-left: 10px;}
}
.recharge-list{
    margin: 0 -10px 30px; display: flex; flex-wrap: wrap;
    li{
        width: 33.33%; box-sizing: border-box; padding: 0 10px; user-select: none; cursor: pointer;
        .box{
            height: 40px; display: flex; justify-content: center; align-items: center; border:1px solid #ccc; border-radius: 6px; margin-bottom: 20px;
        }
        &.active{
            .box{

                background: #fae8ff;
                border: 1px solid rgba(96,3,188,0.60);
            }
        }
        &.other-amount{
            .box{border: none;}
        }
    }
}
.charge-gold{font-size: 18px; color: #6104BD;}
.now-recharge{height: 55px; margin-left: 10px;
    background: linear-gradient(135deg,#a121c0 0%, #5900bc 91%);
    border-radius: 10px;
    font-size: 20px; color: #fff; font-weight: 600; padding: 0 30px; display: flex; align-items:center; user-select: none; cursor: pointer;
    &:hover{background: linear-gradient(135deg,#8411A0 0%, #4A029A 91%);}
}

@media screen and (max-width:768px){
   .recharge-list{
        li{width:50%}
   } 
}
</style>